// extracted by mini-css-extract-plugin
export default {"contentRight":"ContentRight-module__contentRight--ec29","hideOnMobile":"ContentRight-module__hideOnMobile--71eb"};